$(document).ready(function(){
  // alert();

  function updateDawnCart(response) {
    console.log('Product added to cart:', response);

    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        // Parse the response HTML
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newCartDrawer = html.querySelector('.drawer__inner'); // Updated drawer content
        const currentCartDrawer = document.querySelector('.drawer__inner'); // Current drawer in DOM

        if (newCartDrawer) {
          // Replace the current cart drawer content with the fetched content
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        } else {
          console.error('Cart drawer content not found in the response.');
        }
        $('.drawer').removeClass('is-empty');
      })
      .catch((e) => {
        console.error('Error fetching updated cart drawer:', e);
      });
  }

  function openDawnCart(){
    $('cart-drawer').addClass('active');
  }
  
  $(document).on('click', 'button', function(evt) {
      var finder = String($(this).find('span').html());
      if (finder.indexOf('Add to Cart') != -1 ){
          evt.preventDefault();
          evt.stopPropagation()
           evt.stopImmediatePropagation();
  
          var currentId = $(this).attr('data-variant-id');
          
          if (currentId == '49973726839121' 
              || currentId == '49749990605137' 
              || currentId == '49750580822353' 
              || currentId == '50061994328401' 
              || currentId == '49750310420817' 
              || currentId == '50026969301329'
              || currentId == '50061994328401'
              || currentId == '49716608205137' 
             ){
            var sellingPlan = '689299226961';
            var data = {
                id: currentId,
                quantity: 1,
                selling_plan: sellingPlan
            };

            console.log(data);
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                dataType: "json",
                success: function(response) {
                  updateDawnCart(response);
                  openDawnCart();
                   // window.location.href = '/cart';
                },
                error: function() {
                    alert('Error adding the subscription item to the cart.');
                }
            });
          }
          else{
            var data = {
                  id: currentId,
                  quantity: 1
              };

            console.log(data);
              jQuery.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: data,
                  dataType: "json",
                  success: function(response) {
                    updateDawnCart(response);
                    openDawnCart();
                     // window.location.href = '/cart';
                  },
                  error: function() {
                      alert('Error adding the subscription item to the cart.');
                  }
              });
          }

        
 
      }
  });
});
